import { render, staticRenderFns } from "./TenderAdd.vue?vue&type=template&id=e89f35c2&"
import script from "./TenderAdd.vue?vue&type=script&lang=js&"
export * from "./TenderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports